import { useMutation } from "@tanstack/react-query";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function useUpdatePropertyFloor() {
  const axiosPrivate = useAxiosPrivate();

  return useMutation({
    mutationFn: ({ floorId, request }) => {
      return axiosPrivate({
        method: "PUT",
        url: `PropertyFloor/${floorId}`,
        data: request,
      });
    },
  });
}

export default useUpdatePropertyFloor;
